import type { SortOption } from '@/lib/sort';

interface SortSelectProps<T> {
  options: readonly SortOption<T>[];
  value: string;
  onChange: (value: string) => void;
}

/** "Ordenar por" dropdown shared by the list screens (same look as Marcas y categorías). */
export function SortSelect<T>({ options, value, onChange }: SortSelectProps<T>) {
  return (
    <label className="inline-flex items-center gap-2 text-sm text-text-primary">
      Ordenar por
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-9 rounded-md border border-border-strong bg-surface px-2 text-sm text-text-primary focus-visible:border-brand-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
